interface MicButtonProps {
  state: "idle" | "listening" | "thinking" | "speaking";
  onClick: () => void;
  disabled?: boolean;
  customLabel?: string;
}

export function MicButton({ state, onClick, disabled, customLabel }: MicButtonProps): JSX.Element {
  const label =
    customLabel ??
    (state === "listening"
      ? "Stop"
      : state === "thinking"
        ? "Thinking…"
        : state === "speaking"
          ? "Tap to interrupt"
          : "Tap to speak");

  const classes =
    state === "listening"
      ? "bg-lime-500 ring-lime-400/40 text-ink-900"
      : state === "thinking"
        ? "bg-ink-600 text-ink-400 cursor-not-allowed"
        : state === "speaking"
          ? "bg-blue-400 ring-blue-300/40 text-ink-900"
          : "bg-lime-500 hover:bg-lime-400 ring-lime-400/30 text-ink-900";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || state === "thinking"}
      className={`flex flex-col items-center gap-2 px-8 py-5 rounded-full ring-8 shadow-2xl transition-all ${classes} ${
        state === "listening" ? "scale-110" : ""
      }`}
    >
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
        <path d="M12 14a3 3 0 0 0 3-3V5a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3z" />
        <path d="M5 11a7 7 0 0 0 14 0h-2a5 5 0 0 1-10 0H5z" />
        <path d="M11 19h2v3h-2z" />
      </svg>
      <span className="text-sm font-semibold tracking-wide">{label}</span>
    </button>
  );
}
